import NewHeader from "../components_en/NewHeader_dev";
import ProductCSS from "./Product_dev2.module.css";
import Product_dev from "../components_en/product_dev";
import Footer from "../components/Footer";

function Product() {
  return (
    <div className={ProductCSS.content}>
      <NewHeader />
      <Product_dev />
      <br />
            <br />          
            <Footer />   
    </div>
  );
}
export default Product;
